.tabs {
  margin: 1em -20px;


}


.form {
  margin-top: 1em;
}


.checkbox {
  border: 1px solid var(--beigedarker) !important;
  border-radius: 2px; margin-right: 10px;

}


.thumbnails {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1em;

  &.round img {
    border-radius: 50% 50%;
  }

  img {
    border: 4px solid var(--beige);
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.5;
    cursor: pointer;

    &:hover {
      opacity: .7;
    }

    &.active {
      border: 4px solid var(--beigedarker);
      opacity: 1;
    }
  }
}

.uploadButton button
{
  border: 1px solid var(--beigedarker);
  background: var(--beige);
  color: var(--font-color);
}


.images {

  display: flex;
  flex-direction: column;
  gap: .5em;
  margin-top: 0.5em;
  & > div {
    height: 100px;
    border: 1px solid var(--beigedark);
    border-radius: var(--border-radius);


    display: flex;
    flex-direction: row;
    align-items: center;
    .image {
      height: 90px;
      width: 90px;
      object-fit: cover;
      padding: .5em;
    }

    .fileName {
      flex-grow: 1;
      padding: 1em;
    }
    .bin {
      padding: 2em;
      cursor: pointer;
    }
  }
}
